import React from 'react';

const PDFPreview = ({ file, mode = 'modal' }) => {
  if (!file) {
    return <div className="pdf-error">未指定 PDF 文件</div>;
  }

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <iframe
        src={file}
        title="PDF预览"
        width="100%"
        height="100%"
        style={{ border: 'none' }}
      />
    </div>
  );
};

export default PDFPreview; 